import React from 'react';
import propTypes from 'prop-types';
import InstanceWidgetStatistic from 'client/components/Instance/components/InstanceWidgetStatistic';

export default class ConnectableInstanceWidgetStatistic extends React.Component {

  static defaultProps = {
    query: {},
    componentProps: {},
  };

  static propTypes = {
    id: propTypes.string.isRequired,
    statistic: propTypes.string.isRequired,
    reducerKey: propTypes.string,
    title: propTypes.string.isRequired,
    data: propTypes.object,
    Component: propTypes.func,
    componentProps: propTypes.object,
    query: propTypes.object,
  };

  componentDidMount () {
    const { id, reducerKey, statistic, query } = this.props;
    if (reducerKey) {
      this.props.readStatistic(id, reducerKey, statistic, query);
    } else {
      this.props.readStatistic(id, statistic, query);
    }
  }

  render () {
    const { title, Component, data, componentProps, isReading } = this.props;
    return (
      <InstanceWidgetStatistic
        isReading={isReading}
        title={title}
        Component={Component}
        componentProps={componentProps}
        data={data}
      />
    );
  }

}
